import React, { Component } from "react";
import axios from 'axios';

import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";

import { Grid } from 'semantic-ui-react'

import LeftColumn from "../LeftColumn/LeftColumn";
import RightColumn from "../RightColumn/RightColumn";

import { IntlProvider, addLocaleData, injectIntl, defineMessages } from "react-intl";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import enLocaleData from "react-intl/locale-data/en";
import elLocaleData from "react-intl/locale-data/el";
import translations from "../../i18n/locales"
// import addMockData from "./mockData";

import PlayerContext from '../../playerContext'

addLocaleData(enLocaleData);
addLocaleData(elLocaleData);

const messages = defineMessages({
    title: {
        id: 'app.title',
        defaultMessage: 'Welcome'
    }
})



class AppWrapper extends Component {
    render() {
        const locale = window.location.search.replace("?locale=", "") || "en"
        const messages = translations[locale];
        return (
            <IntlProvider locale={locale} key={locale} messages={messages}>
                <AppWithRouting />
            </IntlProvider>
        );
    }
}

class App extends Component {
    constructor(props) {
        super(props);

        this.fileExists = (dir, successCallback, errorCallback) => {
            var xhttp = new XMLHttpRequest;

            /* Check the status code of the request */
            xhttp.onreadystatechange = function () {
                return (xhttp.status !== 404 && xhttp.status !== 0) ? successCallback() : errorCallback();
            };
            /* Open and send the request */
            xhttp.open('head', dir, false);
            xhttp.send();
        };

        this.setCurrentSeconds = (currentSeconds) => {
            this.setState((state) => ({
                currentSeconds: currentSeconds
            }));
        };
        this.setSeekSeconds = (seekSeconds) => {
            this.setState((state) => ({
                seekSeconds: seekSeconds
            }));
        };
        this.setPaused = (paused) => {
            this.setState((state) => ({
                paused: paused
            }));
        };

        this.setYoutubelink = (youtubelink) => {
            this.setState((state) => ({
                youtubelink: youtubelink
            }));
        };

        this.setMetadata = (metadata) => {
            this.setState((state) => ({
                metadata: metadata
            }));
        };

        this.state = {
            currentSeconds: 0,
            seekSeconds: 0,
            paused: true,
            isLoading: true,
            storyId: this.props.match.params.storyId,
            youtubelink: this.props.match.params.youtubelink,
            metadata: {},
            setCurrentSeconds: this.setCurrentSeconds,
            setSeekSeconds: this.setSeekSeconds,
            setPaused: this.setPaused,
            setMetadata : this.setMetadata
        };
    }

    componentDidMount() {
        const storyId = this.props.match.params.storyId;
        // this.fileExists(`/engine/deepData/${storyId}.mp4`, () => console.log("exists"), () => console.log("doesnt exits"))
        //this.props.params.storyid
        // addMockData()
    }



    render() {
        const { intl: { formatMessage } } = this.props;
        return (
            <div className="App">
                <ToastContainer />
                <Grid columns={2} stackable padded stretched style={{ height: '100%' }}>
                    <Grid.Row stretched style={{ margin: '0', padding: '0', "height": "100%" }}>
                        <PlayerContext.Provider value={this.state}>
                            {/* <LeftColumn /> */}
                            <RightColumn />
                        </PlayerContext.Provider>

                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const AppWithRouting = () => (
    <Router > 
        <Route exact path={`${process.env.PUBLIC_URL}/:youtubelink/:storyId`} component={injectIntl(App)} />
    </Router>
);

export default AppWrapper;
